// extracted by mini-css-extract-plugin
export default {"rodapeMobile":"RodapeMobile_rodapeMobile__2PIB9"};